import { render, staticRenderFns } from "./priatedVehicles.vue?vue&type=template&id=ad623400"
import script from "./priatedVehicles.vue?vue&type=script&lang=js"
export * from "./priatedVehicles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports